import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="content has-text-centered">
          <p>©2019 First Federal Bank Member FDIC, Equal Housing Lender</p>
          <a href="https://www.firstfederalwisconsin.com/privacy-and-security/">
            Privacy Policy
          </a>
          <a href="https://www.firstfederalwisconsin.com/privacy-and-security/disclosures/">
            Disclosures
          </a>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js